<p>
  By default, once you publish this product, it will be available at all your
  locations. If you would like to restrict the availability of this product to
  certain locations or Location groups, you can do so by adding exclusions
  below.
</p>
<h6>Exclude from</h6>
<mat-form-field class="w-full" appearance="fill">
  <mat-label>Search Store</mat-label>
  <input
    type="text"
    placeholder="Search Store"
    matInput
    [formControl]="availabilityControl"
    [matAutocomplete]="auto"
    [(ngModel)]="storeSelectedTemp"
  />
  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    (optionSelected)="addStoreSelected($event)"
  >
    <mat-option disabled *ngIf="(filteredOptions | async)?.length === 0">
      <mat-icon
        style="
          .material-symbols-outlined {
            font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
          }
        "
      >
        error
      </mat-icon>
      No matching stores or groups found.
    </mat-option>
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{ option.Name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<h6 style="color: #7f9faf">{{ storeSelectedSet.size }} location added</h6>

<mat-chip-listbox>
  <mat-chip
    *ngFor="let storeSelected of storeSelectedSet"
    color="primary"
    selected
    (removed)="removeExcludeStore(storeSelected)"
  >
    {{ storeSelected.Name }} - {{ storeSelected.City }}
    <button matChipRemove>
      <mat-icon>close</mat-icon>
    </button>
  </mat-chip>
</mat-chip-listbox>
